<div class="modal-body">
   <form (ngSubmit)="login()">
      <div class="form-group">
         <label for="username" [innerHTML]="'MC_USERNAME' | translate"></label>
         <input data-testid="login-input-username" type="text" class="form-control form-control-sm" autocomplete="username" id="username" name="username" [(ngModel)]="username" />
      </div>
      <div class="form-group mt-2">
         <label for="password" [innerHTML]="'MC_PASSWORD' | translate"></label>
         <my-cloud-password-input data-testid="login-input-password" [(value)]="password"></my-cloud-password-input>
      </div>

      @if (errorDescription) {
      <div class="login-error">
         <ngb-alert data-testid="login-alert-error" class="mt-2" type="danger" [dismissible]="false" [innerHTML]="errorDescription"></ngb-alert>
      </div>
      }

      <div class="actions d-flex justify-content-between">
         <a data-testid="login-link-resetPassword" class="reset-password" (click)="resetPassword()">
            <span> {{'MC_LOGON_FORGOT_PASSWORD' | translate}} </span>
         </a>
         <button data-testid="login-btn-submit" (click)="login()" class="btn btn-telenet">{{'MC_LOGIN' | translate}}</button>
      </div>
   </form>
</div>
